module.exports = __webpack_public_path__ + "static/media/chrome-android-allow.d92640c7.jpeg";